import { erstellePuffer, type UsageClientEvent } from '../lib/usageBuffer';

/**
 * Nutzungsspur-Client. Bewusst NICHT über den axios-`api`-Client: dessen
 * 401-Refresh-Interceptor darf durch Tracking nie ausgelöst werden.
 * Fehler werden still geschluckt — Tracking hat keinen sichtbaren Effekt.
 */
export const FLUSH_INTERVALL_MS = 10_000;

const BASIS = import.meta.env.VITE_API_URL || '/api';
const ZIEL = `${BASIS}/usage/events`;

const puffer = erstellePuffer();

export function flushUsage({ beacon = false }: { beacon?: boolean } = {}): void {
  const events = puffer.take();
  if (events.length === 0) return;
  const body = JSON.stringify({ events });
  try {
    if (beacon && typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(ZIEL, new Blob([body], { type: 'application/json' }));
      return;
    }
    fetch(ZIEL, {
      method: 'POST',
      keepalive: true,
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body,
    }).catch(() => {});
  } catch {
    // Tracking-Fehler sind bewusst folgenlos
  }
}

export function trackUsage(event: UsageClientEvent): void {
  try {
    puffer.add(event, Date.now());
    if (puffer.sollteFlushen()) flushUsage();
  } catch {
    // folgenlos
  }
}

if (typeof window !== 'undefined') {
  setInterval(() => flushUsage(), FLUSH_INTERVALL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flushUsage({ beacon: true });
  });
  window.addEventListener('pagehide', () => flushUsage({ beacon: true }));
}
